
import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Button } from '@ellucian/react-design-system/core';
import { ellucianColors } from '../../constants/colors';


const SignIn: React.FC = () => {
    const { oktaAuth } = useOktaAuth();

    useEffect(() => {
        document.body.style.backgroundColor = ellucianColors.primary || '#7100EB';
        document.body.style.margin = '0';
        document.body.style.padding = '0';
        document.body.style.height = '100%';
        const htmlElement = document.documentElement;
        htmlElement.style.backgroundColor = ellucianColors.primary || '#7100EB';
        htmlElement.style.height = '100%';
        oktaAuth.signInWithRedirect();
        return () => {
            document.body.style.backgroundColor = '';
            document.body.style.margin = '';
            document.body.style.padding = '';
            document.body.style.height = '';
            htmlElement.style.backgroundColor = '';
            htmlElement.style.height = '';
        };
    }, [oktaAuth]);

    return null;
};

export default SignIn;